import * as React from "react";
import { Wrapper, Menu, MenuItem, Button } from "react-aria-menubutton";
import styled, { css } from "styled-components";
import * as colors from "../settings/colors";

const StyledPopoverTrigger = styled(Button).attrs({
  tag: "button"
})`
  outline: none;
  background: none;
  border: none;
  padding: 0;
  margin: 0;

  &:not([aria-disabled="true"]):focus {
    box-shadow: 0 0 0 3px #99c6f3;
  }
`;

const PopoverContentMenu = styled(Menu).attrs({
  tag: "nav"
})`
  padding: 0;
  box-sizing: inherit;
  display: inline-block;
  font-size: 14px;
  min-width: 160px;
  max-height: 300px;
  overflow-y: auto;
  background: #FFF;
  box-shadow: 0 0 0 1px rgba(99, 114, 130, 0.16), 0 8px 16px rgba(27, 39, 51, 0.08);
  border-radius: 4px;
  outline: none;

  & > :first-child {
    margin-top: 4px;
  }

  & > :last-child {
    margin-bottom: 4px;
  }
`;

const PopoverContent = ({ attachment, position, children, ...otherProps }) => (
  <div {...otherProps}>
    <PopoverContentMenu>{children}</PopoverContentMenu>
  </div>
);

const StyledPopoverContent = styled(PopoverContent)`
  box-sizing: inherit;
  position: absolute;
  display: flex;
  width: 344px;
  z-index: 10;

  ${({ attachment }) =>
    attachment === "left"
      ? css`
          left: 0;
          right: auto;
          margin-left: -8px;
          justify-content: flex-start;
        `
      : css`
          right: 0;
          left: auto;
          margin-right: -8px;
          justify-content: flex-end;
        `} ${({ position }) =>
      position === "above"
        ? css`
            bottom: 100%;
            margin-bottom: 8px;
          `
        : css`
            top: 100%;
            margin-top: 8px;
          `};
`;

const StyledPopoverContentItem = styled(MenuItem)`
  box-sizing: inherit;
  display: block;
  width: 100%;
  padding: 4px 16px;
  font-size: 14px;
  line-height: 24px;
  color: ${props => props.color || colors.TEXT};
  text-align: left;
  cursor: pointer;

  &:hover,
  &:focus {
    background: #f7f9fa;
  }

  &:focus {
    outline: 0;
  }
`;

const PopoverContentDivider = styled.div`
  margin: 4px 8px;
  background: 1px solid ${colors.DIVIDER};
  height: 1px;
`;

const StyledPopover = styled(Wrapper)`
  box-sizing: border-box;
  position: relative;
`;

export {
  StyledPopover as Popover,
  StyledPopoverTrigger as PopoverTrigger,
  StyledPopoverContent as PopoverContent,
  StyledPopoverContentItem as PopoverContentItem,
  PopoverContentDivider
};



// WEBPACK FOOTER //
// ./src/components/Popover.js